import { render, staticRenderFns } from "./Pickups.vue?vue&type=template&id=51654e4e&scoped=true&"
import script from "./Pickups.vue?vue&type=script&lang=js&"
export * from "./Pickups.vue?vue&type=script&lang=js&"
import style0 from "./Pickups.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Pickups.vue?vue&type=style&index=1&id=51654e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51654e4e",
  null
  
)

export default component.exports